<template>
  <b-container fluid>
    <b-row>
      <b-col lg="6" offset-lg="4"><span><h2>Account Requests By Winery</h2></span></b-col>
    </b-row>
    <b-row style="background-color: gray; margin-top: 20px; color: white" v-if="false">
      <b-col cols="5">Winery</b-col>
      <b-col cols="3">Contact Name</b-col>
      <b-col cols="2">Status</b-col>
      <b-col cols="2">View</b-col>
    </b-row>

    <vue-good-table
        :columns="columns"
        :rows="rows"
        :groupOptions="{
                 enabled: false,
                headerPosition: 'top'
                }"
        :sort-options="{
                    enabled: true,
                    collapsable: true
                }"
        :defaultSortBy="{field: 'status', type: 'certificationDate'}"
        styleClass="vgt-table condensed table-bordered table-striped"
        :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 50,
                    position: 'top',
                    perPageDropdown: [50, 100, 200],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                }">
      <template slot="table-row" slot-scope="props">
                <span v-if="props.column.label === 'View'">
                    <b-button size="sm"
                              @click="goToAccountRequest(props.formattedRow[props.column.field],
                              props.formattedRow['entityType'])">
                            View
                </b-button>
                </span>
        <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                </span>
      </template>
    </vue-good-table>
  </b-container>
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';

export default {
  name: "AccountRequestList",
  components: {
    VueGoodTable
  },
  data() {
    return {
      columns: [
        {
          label: "Business Name",
          field: "businessName",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Winery', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
          }
        },
        {
          label: "Contact Name",
          field: "contactName"
        },
        {
          label: "Organization Type",
          field: "entityType"
        },
        {
          label: "Request Date",
          field: "requestDate",
          type: 'date',
          dateInputFormat: 'T',
          dateOutputFormat: 'MMM dd yy',
        },
        {
          label: "Status",
          field: "status",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Status', // placeholder for filter input
            //filterValue: 'PENDING', // initial populated value for this filter
            filterDropdownItems: [{value: 'APPROVED', text: 'APPROVED'},
              {value: 'DENIED', text: 'DENIED'},
              {value: 'PENDING', text: 'PENDING'}]
          }
        },
        {
          label: "Approval Date",
          field: "decisionDate",
          type: 'date',
          dateInputFormat: 'T',
          dateOutputFormat: 'MMM dd yy',
        },
        {
          label: "View",
          field: "id"
        }],
      rows: []
    }
  },
  mounted() {
    this.$http.get("account/request")
        .then(result => {
          this.rows = result.data;
        })
        .catch(error => {
          console.log(`Couldn't Retrieve Requests, with error: ${error.message}`);
        })
  },
  methods: {
    goToAccountRequest: function (id, entityType) {
      if (entityType === 'WINE') {
        this.$router.push({name: 'Account Request Review', params: {requestId: id}})
      } else {
        this.$router.push({name: 'Vineyard Account Request Review', params: {requestId: id}})
      }
    }
  }
}
</script>

<style scoped>

</style>
